import { translate } from "@/domain/utils/translate";

export type IAlertTypes = 'danger' | 'success' | 'warning' | 'info';

export const getAlertTitles = () => ({
  success: translate('general.success_alert'),
  warning: translate('general.warning_alert'),
  info: translate('general.info_alert'),
  danger: translate('general.danger_alert'),
});

export const alertIcons = {
  success: 'ico-success',
  warning: 'ico-warning',
  info: 'ico-info',
  danger: 'ico-error',
};
